var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 54,
    viewBox: "0 0 68 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.3921 33.3884C65.3921 44.7718 51.3374 54 34 54C16.6625 54 2.60779 44.7718 2.60779 33.3884C2.60779 22.0049 16.6625 12.7767 34 12.7767C51.3374 12.7767 65.3921 22.0049 65.3921 33.3884Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4913 6.87227C13.3679 3.85493 17.2814 2.84511 19.6072 5.03613L36.9619 21.385L5.95029 29.387L12.4913 6.87227Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3927 5.03607C50.7186 2.84506 54.6321 3.85487 55.5087 6.87221L62.0497 29.387L31.038 21.3849L48.3927 5.03607Z",
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0065 29.6097C29.0065 32.4556 25.8123 34.7626 21.8719 34.7626C17.9316 34.7626 14.7374 32.4556 14.7374 29.6097C14.7374 26.7638 17.9316 24.4568 21.8719 24.4568C25.8123 24.4568 29.0065 26.7638 29.0065 29.6097Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2646 29.6097C53.2646 32.4556 50.0704 34.7626 46.1301 34.7626C42.1897 34.7626 38.9955 32.4556 38.9955 29.6097C38.9955 26.7638 42.1897 24.4568 46.1301 24.4568C50.0704 24.4568 53.2646 26.7638 53.2646 29.6097Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4441 24.4568H23.2979V34.7626H20.4441V24.4568Z",
    fill: "#212121"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7023 24.4568H47.5561V34.7626H44.7023V24.4568Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.018b6643f3dd14ed8a10432df1ab2a2b.svg";
export { ForwardRef as ReactComponent };